import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

const StyledRoundedContainer = styled.div<{
  $padding?: number;
  $fullHeight?: boolean;
}>`
  box-shadow: 0px 2px 8px 0px rgba(74, 74, 79, 0.08);
  border-radius: ${theme.variables.border_radius_2};
  background-color: white;
  position: relative;
  padding: ${(props) => (props.$padding ? `${props.$padding}px` : 0)};
  height: ${(props) =>
    props.$fullHeight
      ? `calc(100% - ${props.$padding ? props.$padding * 2 : 0}px)`
      : "unset"};
  overflow: hidden;

  & .rounded-container-title {
    margin-bottom: 16px;
    display: block;
  }
`;

export { StyledRoundedContainer };
